import { JsStyles } from '../jss-style';
import { GapClasses } from '@sheinx/base';

const gapStyle: JsStyles<keyof GapClasses> = {
  item: {},
  wrapper: {},
};

export default gapStyle;
